<template>
    <div>
        <h1 style="font-size: 24px; color: black;">事件日报
            <span>用户类型：</span>
            <el-select v-model="queryData.user" clearable placeholder="请选择">
                <el-option v-for="item in users" :label="item.name" :key="item.id" :value="item.id"></el-option>
            </el-select>
            <span> 弹窗名称：</span>
            <el-select v-model="queryData.eventName" @change="filterEventName" clearable filterable placeholder="请选择">
                <el-option v-for="item in popList" :label="item.name" :key="item.id" :value="item.id"></el-option>
            </el-select>
        </h1>
        <div class="block">
            <span class="demonstration">日期：</span>
            <el-date-picker
                v-model="queryData.timeDate"
                type="daterange"
:clearable="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>&emsp;&emsp;&emsp;
            <span>渠道：</span>
            <el-select v-model="queryData.channelId" @change="selectGoodsByChannelId($event)" clearable
                       placeholder="请选择">
                <el-option value="0" label="全部"></el-option>
                <el-option v-for="item in channelList" :label="item.name" :key="item.id" :value="item.id"></el-option>
            </el-select>
            <el-select v-model="queryData.subChannelId" clearable placeholder="请选择">
                <el-option value="0" label="全部"></el-option>
                <el-option v-for="item in subChannelList" :label="item.name" :key="item.id"
                           :value="item.subChannel"></el-option>
            </el-select>

            <el-button type="primary" class="margin-left-10" @click="query">查询</el-button>
            <el-button type="primary" @click="exportExcel()">导出报表</el-button>
        </div>
        <h1>
            <el-table border :header-cell-style="{background:'#282828'}"
                      :data="plateReportList"
                      ref="filterTable"
                      max-height="820" @sort-change='sortChange'>
                <el-table-column prop="dt" label="日期" sortable="custom"></el-table-column>
                <el-table-column  label="弹窗名称">
                    <template slot-scope="scope">
                        {{ scope.row.popupName }}
                    </template>
                </el-table-column>
                <el-table-column label="事件名称">
                    <template slot-scope="scope">
                        {{ scope.row.eventName }}
                    </template>
                </el-table-column>

                <el-table-column label="曝光率" sortable="custom" prop="exRate">
                    <template slot-scope="scope">
                        {{ scope.row.exRate == null ? '0.00%' :(scope.row.exRate*100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>

                <el-table-column label="点击用户数" sortable="custom" prop="userClick">
                    <template slot-scope="scope">
                        {{ scope.row.userClick }}
                    </template>
                </el-table-column>

                <el-table-column label="曝光用户数" sortable="custom" prop="exUser">
                    <template slot-scope="scope">
                        {{ scope.row.exUser }}
                    </template>
                </el-table-column>

                <el-table-column label="曝光次数" sortable="custom" prop="exUser">
                    <template slot-scope="scope">
                        {{ scope.row.exCount }}
                    </template>
                </el-table-column>

                <el-table-column label="用户点击率" sortable="custom" prop="userClickRate">
                    <template slot-scope="scope">
                        {{ scope.row.userClickRate == null ? '0.00%' :(scope.row.userClickRate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>

                <el-table-column label="人均点击次数" sortable="custom" prop="userClickPerRate">
                    <template slot-scope="scope">
                        {{ scope.row.userClickPerRate == null ? '0.00' :scope.row.userClickPerRate.toFixed(2) }}
                    </template>
                </el-table-column>

                <el-table-column label="人均曝光次数" sortable="custom" prop="userClickPerRate">
                    <template slot-scope="scope">
                        {{ scope.row.exPerUser == null ? '0.00' :scope.row.exPerUser.toFixed(2) }}
                    </template>
                </el-table-column>
            </el-table>
            <el-row>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pagenum"
                    :page-sizes="[20,30,50]"
                    :page-size="queryInfo.pagesize"
                    layout="total, sizes, prev, pager, next"
                    :total="queryInfo.total">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
import {channelList, downloadData, eventList, eventListEvent, eventPlateReportSearch} from "@/http/api";
import utils from '@/utils'


export default {
    name: "EventReport",
    data() {
        return {
            queryInfo: {
                pagesize: 20,
                pagenum: 1,
                total: 0,
            },
            queryData: {
                user: 0,
                state: 0,
                timeDate: ['', ''],
                channelId: '',
                subChannelId: '',
                eventName: '',
                popId:null
            },
            queryTrueData: {
                state: 0,
                startTime: '',
                endTime: '',
                order: null,
                prop: null,
                channelId: '',
                subChannelId: '',
                popId:null
            },
            users: [{id: 0, name: '全部'},
                {id: 1, name: '新用户'},
                {id: 2, name: '老用户'}],
            eventList: [],
            popList: [],
            tempEvenId: [],
            plateReportList: [],
            channelList: [],
            subChannelList: [],
            watchTag: '',
            pids: new Set(),
        }
    },
    methods: {
        selectGoodsByChannelId(val) {
            this.watchTag = val;
            if (val !== null && val !== '' && val !== undefined && val !== '0') {
                this.subChannelList = this.channelList.filter(channel => channel.id === val)[0].children.filter(subChannel => subChannel.state === 1);
            }
            if (val === '0') {
                this.subChannelList = [];
            }
        },
        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize;
            this.queryPlateReportList();

        },
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage;
            this.queryPlateReportList();
        },
        query() {
            this.queryInfo.pagenum = 1;
            this.queryPlateReportList();
        },
        exportExcel() {
            let fileName = new Date().toLocaleString() + '事件日报.xlsx';
            downloadData(
                '/plate/searchEventPlateReportExcel',
                Object.assign(this.queryTrueData),
                fileName
            )
        },
        queryPlateReportList() {
            this.queryTrueData.startTime = this.queryData.timeDate[0];
            this.queryTrueData.endTime = this.queryData.timeDate[1];
            this.queryTrueData.channelId = this.queryData.channelId;
            this.queryTrueData.subChannelId = this.queryData.subChannelId;
            this.queryTrueData.state = this.queryData.state;
            this.queryTrueData.size = this.queryInfo.pagesize;
            this.queryTrueData.page = this.queryInfo.pagenum;
            this.queryTrueData.user = this.queryData.user;
            eventPlateReportSearch(this.queryTrueData).then(resp => {
                this.plateReportList = resp.data.info.list;
                this.$forceUpdate();
                this.queryInfo.total = resp.data.info.totalElements;
            });
        },
        filterEventName(popId) {
            //获取 popId 相同的eventId list
            this.queryTrueData.popId = popId;
        },
        sortChange(order) {
            this.queryTrueData.order = order.order;
            this.queryTrueData.prop = order.prop;
            this.queryPlateReportList();
        }
    },

    watch: {
        watchTag() {
            this.queryData.subChannelId = '';
        }
    },
    created() {
        this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
        channelList().then(resp => {
            this.channelList = resp.data.info;
        });
        //获取全部事件
        eventList().then(resp => {
            this.popList = resp.data.info;
        });
        eventListEvent().then(resp => {
            this.eventList = resp.data.info;
        });
        this.queryPlateReportList();
    }
}
</script>

<style scoped>

</style>
